import { const_var, params } from "../../redux/reducers/reducer";
import { makeDimensionArray } from "../building/building_style/centreBuilding.helper";
import centerBuildingsWallOptionsHelpers from "../building/building_wall/centerBuildingsWallOptions.helpers";
import { handlCupolaPositionOnDimensionChange, removeAllCupolas, updataOrRemoveCupola } from "../building_component/buildingComponent.helper";
import utilityStorageOptionsHelpers from "../building_pricing/utility_pricing/utilityStorageOptions.helpers";
import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer";
import * as cuComponent from "../../redux/reducers/building_component/componentReducer";
import * as utils from "../../redux/reducers/utils";
import { AddDoorComponentonWall, updateBreezewayFrameAndStorages } from "./common.helper";
import { getSidingOrientationOptions } from "../building/building_material/buildingMaterial.helper";
import React from "react";
import { updateWainscotPriceFlag } from "../building/building_color/wainscotColor.helper";
import { extraAddOnFormulaCal } from "../extra_options_pricing/extraOptions.helper";
import { updateFunctionsOnLeantoRemoval } from "../lean_building_pricing/lean_building_wall/leanBuildingWall.helper";
import { makeTranslucent } from "../building/building_config/componentConfig";

export const handleShowfeedbackData = (state, action) => {
	if (action.category == "prompt") {
		state.isFeedbackcontent = true;

		if (const_var.loginSession == true) {
			state.isFeedbackcontent = true;
		}

		state.isShowfeedback = !state.isShowfeedback;
		const_var.feedback_object_to_server.success = false;
		const_var.feedback_object_to_server.feedback = "";
		const_var.feedback_object_to_server.feedback_email = "";
		const_var.feedback_object_to_server.first_name = "";
		const_var.feedback_object_to_server.last_name = "";
		const_var.feedback_object_to_server.phone_number = "";
		const_var.displayerrorMessage["feedback"] = "";
		const_var.displayerrorMessage["feedback_first_name"] = "";
		const_var.displayerrorMessage["feedback_last_name"] = "";
		const_var.displayerrorMessage["feedback_email"] = "";
		const_var.displayerrorMessage["feedback_phone_number"] = "";
		state.emojiname = "love";
		state.emojiindex = 4;
	} else {
		if (action.category == "validation") {
			const_var.feedback_object_to_server.dislike_count = false;
		}

		if (action.category == "handleShowfeedbackloader") {
			state.isShowfeedbackloader = true;
		}

		if (action.category == "success") {
			state.isShowfeedbackloader = false;
			const_var.feedback_object_to_server.dislike_count = false;
			const_var.feedback_object_to_server.feedback = "";
			const_var.feedback_object_to_server.success = true;
			const_var.feedback_object_to_server.like_count = false;
			state.emojiindex = 4;
			const_var.isFeedbackFieldMandatory = false;
			const_var.feedback_object_to_server.feedback_email = "";
			const_var.feedback_object_to_server.first_name = "";
			const_var.feedback_object_to_server.last_name = "";
			const_var.feedback_object_to_server.phone_number = "";
			const_var.displayerrorMessage["feedback"] = "";
			const_var.displayerrorMessage["feedback_first_name"] = "";
			const_var.displayerrorMessage["feedback_last_name"] = "";
			const_var.displayerrorMessage["feedback_email"] = "";
			const_var.displayerrorMessage["feedback_phone_number"] = "";
			state.emojiname = "love";
			state.emojiindex = 4;
		}
		if (action.category == "dislike") {
			const_var.feedback_object_to_server.dislike_count = !const_var.feedback_object_to_server.dislike_count;
		}
		if (action.category == "like") {
			const_var.feedback_object_to_server.like_count = !const_var.feedback_object_to_server.like_count;
			if (const_var.feedback_object_to_server.like_count == true) {
				const_var.feedback_object.like_count = const_var.feedback_object.like_count + 1;
			} else {
				const_var.feedback_object.like_count = const_var.feedback_object.like_count - 1;
			}
		}

		if (action.category == "emojis") {
			const emojisArray = ["very_sad", "sad", "confused", "happy", "love"];
			state.emojiname = emojisArray[action.typen];
			state.emojiindex = action.typen;
			const_var.isFeedbackFieldMandatory = false;
			const_var.feedback_object_to_server.like_count = state.emojiname;
			const_var.feedback_object_to_server.feedback = "";
			const_var.feedback_object_to_server.feedback_email = "";
			const_var.feedback_object_to_server.first_name = "";
			const_var.feedback_object_to_server.last_name = "";
			const_var.feedback_object_to_server.phone_number = "";
			const_var.displayerrorMessage["feedback"] = "";
			const_var.displayerrorMessage["feedback_first_name"] = "";
			const_var.displayerrorMessage["feedback_last_name"] = "";
			const_var.displayerrorMessage["feedback_email"] = "";
			const_var.displayerrorMessage["feedback_phone_number"] = "";
		}
		if (action.category == "feedback") {
			const_var.feedback_object_to_server.feedback = action.event.target.value;
			if (action.event.target.value.length > 0) {
				const_var.displayerrorMessage["feedback"] = "";
			}
		}
		if (action.category == "feedback_name") {
			const_var.feedback_object_to_server.feedback_name = action.event.target.value;
		}
		if (action.category == "feedback_email") {
			let emailRegEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

			if (emailRegEx.test(action.event.target.value)) {
				const_var.displayerrorMessage["feedback_email"] = "";
			} else {
				const_var.displayerrorMessage["feedback_email"] = "Invalid Email";
			}
			const_var.feedback_object_to_server.feedback_email = action.event.target.value;
		}
		if (action.category == "first_name") {
			const_var.feedback_object_to_server.first_name = action.event.target.value;
			if (action.event.target.value.length > 0) {
				const_var.displayerrorMessage["feedback_first_name"] = "";
			}
		}
		if (action.category == "last_name") {
			const_var.feedback_object_to_server.last_name = action.event.target.value;
			if (action.event.target.value.length > 0) {
				const_var.displayerrorMessage["feedback_last_name"] = "";
			}
		}
		if (action.category == "phone_number") {
			let numberRegex = /^\d+$/;
			if (numberRegex.test(action.event.target.value) || action.event.target.value == "") {
				const_var.feedback_object_to_server.phone_number = action.event.target.value;
			}

			if (const_var.feedback_object_to_server && const_var.feedback_object_to_server.phone_number && const_var.feedback_object_to_server.phone_number.length < 10) {
				const_var.displayerrorMessage["feedback_phone_number"] = "Please Enter a valid 10-digit phone number";
			} else {
				const_var.displayerrorMessage["feedback_phone_number"] = "";
			}
		}
	}
	return {
		...state,
		action
	};
};
export const handleIconClick = (state, action, utils) => {
	updateWainscotPriceFlag();
	if (action.value == "door") {
		let id = action.doorUniqueId;
		let doorObj = const_var.newDoorsArray.find((door) => door.uniqueId === Number(id));
		let doorObjNew = const_var.entry_points.find((door) => door.uniqueId === Number(id));
		if (doorObj) {
			const_var.showComponentEditBox = true;
			const_var.doorUniqueId = doorObj.uniqueId;
			params.trimkit = doorObj.DoorObj != undefined ? doorObj.DoorObj.trimkit : false;
			params.header_seal = doorObj.DoorObj != undefined ? doorObj.DoorObj.header_seal : false;
			params.chain_hoist = doorObj.DoorObj != undefined ? doorObj.DoorObj.chain_hoist : false;
			params.automatic_openers = doorObj.DoorObj != undefined ? doorObj.DoorObj.automatic_openers : false;
			params.insulated = doorObj.DoorObj != undefined ? doorObj.DoorObj.insulated : false;
			params.motor = doorObj.DoorObj != undefined ? doorObj.DoorObj.motor : false;
			if (params.m_s_n == 9 /* && doorObjNew!=undefined && doorObjNew.parent_array_key=="Walk" */) {
				params.threshold = doorObj.DoorObj != undefined ? doorObj.DoorObj.threshold : false;
			}
			doorObjNew &&
				Object.keys(doorObjNew).map((e) => {
					if (e.includes("add_on_options") && !e.includes("_is") && !e.includes("_price")) {
						let prop = e.replace("entry_", "");
						params[prop] = doorObjNew[e] != undefined ? doorObjNew[e] : false;
					}
				});

			params.certified_door = doorObj.DoorObj != undefined ? doorObj.DoorObj.certified_door : false;
			params.extra_notes = doorObj.DoorObj != undefined ? doorObj.DoorObj.entry_note : params.extra_notes;
		}

		if (const_var.showComponentEditBox == true) {
			setTimeout(() => {
				let windowInnerHeight = window.innerHeight;
				let windowInnerWidth = window.innerWidth;
				let shiftDwBox = document.querySelector(".door-window-drag-inner");
				let DwEditBoxPos = document.querySelector(".door-window-drag-inner").getBoundingClientRect();
				let getTransform = shiftDwBox.style.transform.split("translate(");
				let getTransformnew = getTransform[1].replace(")", "").split(",");
				let getTransformX = getTransformnew[0].replace("px", "");
				let getTransformY = getTransformnew[1].replace("px", "");
				let OpencheckDwEditPos = document.querySelector(".dw-show-edit-box-bottom").getBoundingClientRect();
				let diffrenceBottom = Math.abs(windowInnerHeight - OpencheckDwEditPos.top) + 80;
				let diffrenceLeft = Math.abs(OpencheckDwEditPos.left);
				let finaltransformTop = getTransformY - diffrenceBottom;
				let finaltransformLeft = getTransformX;

				if (OpencheckDwEditPos.top + 60 > windowInnerHeight) {
					shiftDwBox.style.transform = `translate(${finaltransformLeft}px, ${finaltransformTop}px)`;
				}
				if (Math.sign(OpencheckDwEditPos.left) === -1) {
					shiftDwBox.style.transform = `translate(20px, ${finaltransformTop}px)`;
				}

				if (Math.sign(DwEditBoxPos.top) === -1) {
					shiftDwBox.style.transform = `translate(${finaltransformLeft}px, 0)`;
				}

				if (OpencheckDwEditPos.right > windowInnerWidth) {
					shiftDwBox.style.transform = `translate(${windowInnerWidth - 350}px, ${getTransformY}px)`;
				}
			}, 300);
		}
	}
	if (action.value == "cupola") {
		let id = action.doorUniqueId;
		let cupolaObj = const_var.cupolas.find((cupola) => cupola.uniqueId === Number(id));
		if (cupolaObj) {
			const_var.showCupolaEditBox = true;
			const_var.cupolaUniqueId = cupolaObj.uniqueId;
		}
	}
	return {
		...state,
		action
	};
};
export const handleAlert = (state, action) => {
	const_var.chknewCount++;
	if (state.const_var.alertUsedFor == "FULLYENCLOSED") {
		state.isFullyEnclosedChecked = !state.isFullyEnclosedChecked;
		centerBuildingsWallOptionsHelpers.closeCenterWalls(state, {
			resetLeantoStoragePrice: (leanType) => utilityStorageOptionsHelpers.resetLeanToStoragePrice(state, leanType)
		});
	} else if (state.const_var.alertUsedFor == "ADDUTILITY") {
		state.params.p_u_c = !state.params.p_u_c;
		utilityStorageOptionsHelpers.applyCenterUtilityCheckbox(state);
	} else if (state.const_var.alertUsedFor == "REMOVECOMPONENT") {
		state.isShowEditIconSection = false;
		state.const_var.showComponentDeleteAlert = false;
		cuComponent.removeComponentFromWall(const_var.doorUniqueId);
	} else if (state.const_var.alertUsedFor == "noSpaceAvailableOnWall") {
		state.isShowEditIconSection = false;
		state.const_var.showComponentEditBox = false;
		clearTimeout(const_var.timer);
	} else if (state.const_var.alertUsedFor == "CancelOrderQuote") {
		state.isfullviewbuilding = false;
		if (const_var.crmSetting.is_Action_url != "order/save" && const_var.crmSetting.is_Action_url != "order/update") {
			window.location.href = const_var.crmSetting.web_url + "/" + const_var.targetRedirectUrl[const_var.crmSetting.is_module_name].view + const_var.crmSetting.is_module_id;
		} else {
		}
	} else if (state.const_var.alertUsedFor == "removeCupola") {
		state.isShowEditIconSection = false;
		updataOrRemoveCupola(const_var.cupolaUniqueId, "", "", "", "", "", "", "", "", "remove");
		state.cupolaEditIconsPos = [];
	} else if (state.const_var.alertUsedFor == "YourCanNotAddPorch") {
		cuBuilding.cP();
	} else if (state.const_var.alertUsedFor == "nonVerticalRoofStyleForTubulerBuildingMnf") {
		state.params.p_r_s = state.holdCurrentRoofStyle;
		if (const_var.DistanceArr[params.p_b_t][params.p_r_s] == undefined) {
			const_var.DistanceArr[params.p_b_t][params.p_r_s] = params.isDefaultfourFeet || params.fourth_center_cost ? 4 : 5;
		}
		makeDimensionArray(state);
		cuBuilding.BuildingUpdate();
		if (params.add_left_lean) {
			cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
			cuBuilding.UpdateLeftLean();
		}
		if (params.add_right_lean) {
			cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
			cuBuilding.UpdateRightLean();
		}
		if (params.add_front_lean) updateFunctionsOnLeantoRemoval("frontLean");
		if (params.add_back_lean) updateFunctionsOnLeantoRemoval("backLean");
	} else if (state.const_var.alertUsedFor == "clearComponent") {
		state.isShowEditIconSection = false;
		updateWainscotPriceFlag();
		cuComponent.removeAlltheComponent();
		state.const_var.cupolaObj = {};
		removeAllCupolas();
		if (!params.is_translusant && state.const_var.selectedTabKeyForWheel == "doorwindow") {
		}
	} else if (state.const_var.alertUsedFor == "NoMfgExsist") {
		const_var.crmSetting.is_quote_Edit = false;
		const_var.crmSetting.is_Edit = false;
		state.const_var.isShowAlert = false;
		state.const_var.alertUsedFor = "";
		state.isShowSummaryModal = false;
		state.selectedTabstate = "statechange";
	}

	state.const_var.isShowAlert = false;
	state.const_var.alertUsedFor = "";
	params.preAction = {};
	return {
		...state,
		newColor: action + state.const_var.isShowAlert + state.const_var.alertUsedFor + state.const_var.showComponentEditBox + state.const_var.showComponentDeleteAlert + const_var.chknewCount
	};
};
export const handleAlertCancel = (state, action) => {
	const_var.chknewCount++;

	if (state.const_var.alertUsedFor == "nonVerticalRoofStyleForTubulerBuildingMnf") {
		state.params.p_r_s = state.holdPreviousRoofStyle;
		makeDimensionArray(state);
		cuBuilding.BuildingUpdate(true, "");
		if (params.isBreezeway /* && chkEdit != "edit" */) updateBreezewayFrameAndStorages({ option: "buildingHeight" }, undefined, Number(params.p_h));
		if (params.cupola) handlCupolaPositionOnDimensionChange("roofPitch");
		if (params.add_front_lean) cuBuilding.UpdateFrontLean();
		if (params.add_left_lean) cuBuilding.UpdateLeftLean();
		if (params.add_right_lean) cuBuilding.UpdateRightLean();
		if (params.add_back_lean) cuBuilding.UpdateBackLean();
	}
	if (state.const_var.alertUsedFor == "REMOVECOMPONENT" || state.const_var.alertUsedFor == "noSpaceAvailableOnWall") {
		state.isShowEditIconSection = false;
		state.const_var.showComponentEditBox = false;
		state.const_var.showComponentDeleteAlert = false;
	}
	if (state.const_var.alertUsedFor == "YourCanNotAddPorch1") {
		for (const key in params.params_cancel) {
			params[key] = params.params_cancel[key];
		}
		//
		cuBuilding.CheckLeanLegsByResponse(state, "all");
		cuBuilding.BuildingUpdate(true, "");
		if (params.cupola) handlCupolaPositionOnDimensionChange("h");
		if (const_var.entry_points.length > 0) {
		}
		if (params.add_left_lean == true) {
			const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
			cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
		}
		if (params.add_front_lean == true) {
			const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
			cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
		}
		if (params.add_back_lean == true) {
			const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.left_back_wrap_connection_fee_changed = true;
			cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
		}
		if (params.add_right_lean == true) {
			const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
			const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
			cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
		}
		cuBuilding.cP();
	}
	state.const_var.isShowAlert = false;
	state.const_var.alertUsedFor = "";
	params.preAction = {};
	return {
		...state,
		newColor: action + state.const_var.isShowAlert + state.const_var.alertUsedFor + state.const_var.showComponentEditBox + state.const_var.showComponentDeleteAlert + const_var.chknewCount
	};
};
export const checkSnowBuilding = (state, action) => {
	params.isSnowLoad = !params.isSnowLoad;
	state.const_var.selSidingOption = "metal";
	state.params.wallOrientation = "horizontal";
	state.params.wallTexture = "none";
	state.const_var.selSidingObj = {
		name: "metal",
		label: "Metal",
		price_type: "$",
		price_of: [],
		panel_price_from: ["vertical"],
		panel_orientation: ["horizontal", "vertical"],
		cost: 0
	};
	state.const_var.sidingOrientationOptions = getSidingOrientationOptions();
	if (params.isSnowLoad == true) {
		const_var.CheckSnowLoadValue = 65;
	} else {
		const_var.CheckSnowLoadValue = 35;
	}
	if (const_var.checkmoreCustomizeFlag == true && !params.isSnowLoad && const_var.stateData != undefined) {
		const_var.hide_price_calculation = const_var?.stateData?.hide_price_calculation;
		document.querySelector("body").classList.remove("active-hidden-price");
	}
	if (const_var.checkmoreCustomizeFlag == true && params.isSnowLoad && const_var.stateData != undefined) {
		const_var.hide_price_calculation = 1;
		document.querySelector("body").classList.remove("active-hidden-price");
	}
	const_var.eventKey = "garages";
	return {
		...state,
		CheckSnowLoadBuilding: params.isSnowLoad
	};
};
export const handleLoftChange = (state, action) => {
	state.const_var.selLoftVal[action.isFor] = action.value;
	if (state.const_var.isLTBuilding && action.isFor) {
		let resetFor = action.isFor;
		if (resetFor == "center") {
			resetFor = "centerBuilding";
		}
		state.const_var.lNTBuildingData.updatePriceDataElements[resetFor][action.label]["is_edit"] = false;
	}
	if (const_var.isLTBuilding && action.isFor == "left") {
		let list = const_var.extraAddOnItemsArrayList.left;
		extraAddOnFormulaCal(action.index, list, "leftLean");
		cuBuilding.UpdateLeftLean();
	} else if (const_var.isLTBuilding && action.isFor == "right") {
		let list = const_var.extraAddOnItemsArrayList.right;
		extraAddOnFormulaCal(action.index, list, "rightLean");
		cuBuilding.UpdateRightLean();
	} else if (const_var.isLTBuilding && action.isFor == "front") {
		let list = const_var.extraAddOnItemsArrayList.front;
		extraAddOnFormulaCal(action.index, list, "frontLean");
		cuBuilding.UpdateFrontLean();
	} else if (const_var.isLTBuilding && action.isFor == "back") {
		let list = const_var.extraAddOnItemsArrayList.back;
		extraAddOnFormulaCal(action.index, list, "backLean");
		cuBuilding.UpdateBackLean();
	} else {
		extraAddOnFormulaCal(action.index);
	}
	const_var.UpdatedPriceData.elements[action.label.toString()].is_edit = false;
	cuBuilding.cP();
	return {
		...state,
		action
	};
};
export const handleAddRemoveComponent = (state, action) => {
	if (action.typeMatch == "extra_anchors") {
		if (action.key == "add") {
			state.const_var.inputs.push({
				additional_name: "",
				additional_quantity: ""
			});
		}
		if (action.key == "remove") {
			state.const_var.inputs.splice(action.index, 1);
			if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
				const_var.UpdatedPriceData.certificate_price_changed = true;
			}
			cuBuilding.cP();
		}
	}
	if (action.typeMatch == "addNewComponent") {
		if (action.key == "add") {
			state.const_var.Componentinputs.push({
				additional_name: "",
				additional_quantity: ""
			});
		}
		if (action.key == "remove") {
			delete state.const_var.Componentinputs.splice(action.index, 1);
			if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
				const_var.UpdatedPriceData.certificate_price_changed = true;
			}
			cuBuilding.cP();
		}
	}
	if (action.typeMatch == "addMoreTax") {
		if (action.key == "add") {
			state.const_var.MoreTaxinputs.push({
				name: "",
				type: "%",
				percentage: ""
			});
		}
		if (action.key == "remove") {
			if (state.const_var?.post_data?.building?.tax) {
				state.const_var.post_data.building.tax.splice(action.index + 1, 1);
			}
			if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
				const_var.UpdatedPriceData.certificate_price_changed = true;
			}
			state.const_var.MoreTaxinputs.splice(action.index, 1);
			cuBuilding.cP();
		}
	}

	return {
		...state,
		newColor: action.value + action.key + state.const_var.inputs.length + action.index + action.typeMatch + state.const_var.MoreTaxinputs.length + state.const_var.Componentinputs.length
	};
};
export const handleEditComponentSize = (state, action) => {
	params.certified_door = false;
	if (action.dropdownType == "Width") {
		state.const_var.frameDimension = action.comName;
	}
	if (action.dropdownType == "Height") {
		state.const_var.frameHDimension = action.comName;
	}
	if (action.trimdoor != "") {
		state.params.trimkit = !state.params.trimkit;
	} else {
		state.params.trimkit = false;
	}
	if (action.dropdownType == "Width" || action.dropdownType == "Height") {
		let valData = const_var.editComponentDimension.replace("_Frameout", "").split("X");
		state.const_var.frameHDimension = state.const_var.frameHDimension == "" ? valData[1] : state.const_var.frameHDimension;
		state.const_var.frameDimension = state.const_var.frameDimension == "" ? valData[0] : state.const_var.frameDimension;
	}
	if (action.dropdownType == "WidthHeight") {
		action.comName = "CustomGarageSize";
		const_var.editComponentDimension = "CustomGarageSize";
	} else {
		action.comName = action.dropdownType != "" ? state.const_var.frameDimension + "X" + state.const_var.frameHDimension : action.comName;
	}
	if (action.comName == "CustomGarageSize") {
		params.certified_door = false;
	}
	return {
		...state,
		newColor: action.comName + action.comType + action.comId + state.params.trimkit
	};
};
export const handleCloneComponent = (state, action) => {
	let editData = action.doorObj;
	let noDoorAdded = false;
	if (
		params.m_s_n == 11 &&
		const_var.entry_wall_location[editData.component_wall_name].includes("end") &&
		(editData.parent_array_key == "Garage" || editData.parent_array_key == "Garage_Frameout") &&
		editData.entry_dimension_height >= params.p_h
	) {
		noDoorAdded = true;
	}

	if (noDoorAdded === true) {
		const_var.isShowAlert = true;
		const_var.alertUsedFor = "NoMoreGarageDoorsCanBeAdded";
		const_var.showComponentEditBox = false;
	} else {
		params.trimkit = editData != undefined ? editData.entry_trim_kit : false;

		AddDoorComponentonWall(
			editData.entry_type,
			editData.component_name,
			editData.component_wall_name,
			editData.name,
			editData.parent_array_key,
			editData.child_array_key,
			editData.nested_array_key,
			editData.entry_rotation == undefined ? 0 : editData.entry_rotation,
			editData.entry_position,
			undefined,
			action.doorObj
		);
		state.const_var.showComponentEditBox = false;
		if (state.const_var.isShowAlert == true && state.const_var.alertUsedFor == "noSpaceAvailableOnWall") {
			state.const_var.showComponentEditBox = false;
		}
	}
	return {
		...state,
		action
	};
};
export const handleConfirmAlert = (state, action) => {
	if (action.key == "cancel") {
		state.const_var.isShowAlert = true;
		state.const_var.alertUsedFor = "CancelOrderQuote";
	}
	if (action.key == "captuareIMG") {
		state.const_var.isShowAlert = true;
		state.const_var.alertUsedFor = "captuareIMG";
	}
	if (action.key == "compare") {
		state.const_var.isShowCompare = !state.const_var.isShowCompare;
		document.querySelector("body").classList.toggle("active-twod-drawing-popup");
		document.querySelector("body").classList.toggle("modal-open");
		state.const_var.ComparisionDataArray = {};
		params.m_s_n_1 = 0;
		params.m_s_n_2 = 0;
		params.m_n_f_1 = params.m_n_f_2 = "Select";
		state.const_var.NoCompareData1 = false;
		state.const_var.NoCompareData2 = false;
		state.const_var.comparisionLoadermfg1 = false;
		state.const_var.comparisionLoadermfg2 = false;
		params.showCompareMnfList_1 = params.showCompareMnfList_2 = false;
		state.cupolaEditIconsPos = [];
		state.doorWindowIconsPos = [];
	}
	if (action.key == "customBuilding") {
		state.const_var.isShowAlert = true;
		state.const_var.alertUsedFor = "customBuildings";
	}
	return {
		...state,
		newColor: action + const_var.isShowAlert + const_var.alertUsedFor + state.const_var.isShowCompare
	};
};
export const handleAccordian = (state, action) => {
	var sections = document.querySelectorAll(".accordion-type-2 .card");
	let wainscotSections = document.querySelectorAll(".color-accordion .card");
	if (action.value.currentTarget.parentNode.parentNode.classList.contains("active") == true) {
		action.value.currentTarget.parentNode.parentNode.classList.remove("active");
	} else {
		sections = action.value.currentTarget.parentNode.parentNode.parentNode.children;
		for (let i = 0; i < sections.length; i++) {
			sections[i].classList.contains("active");
			sections[i].classList.remove("active");
			wainscotSections[i]?.childNodes?.[1]?.classList?.remove("show");
		}

		action.value.currentTarget.parentNode.parentNode.classList.add("active");
	}
	const_var.accodionEvent = action.value.currentTarget.parentNode.parentNode.classList;

	return {
		...state,
		action
	};
};
export const handleDeviceCapture = (state, action) => {
	document.querySelector("body").classList.remove("active-offset-thumbnail");

	state.const_var.ClickforPhotosMobile = React.createRef();
	setTimeout(() => {
		state.const_var.ClickforPhotosMobile.current.click();
	}, 100);

	if (action.key == "redirect") {
		const capturescroll = document.querySelector(`#${action.id}`);
		setTimeout(function () {
			capturescroll.scrollIntoView({ behavior: "smooth" });
		}, 500);
	}
	return {
		...state,
		action
	};
};
export const handleShowWhatThis = (state, action) => {
	state.const_var.stateHelpTextContent = false;
	state.const_var.colorsHelpTextContent = false;
	state.const_var.buildSizeHelpTextContent = false;
	state.const_var.leantoHelpTextContent = false;
	state.const_var.wallsHelpTextContent = false;
	state.const_var.doorWindowHelpTextContent = false;
	state.const_var.extraHelpTextContent = false;
	state.isShowWhatThis = true;

	if (action.value == "state") {
		state.const_var.stateHelpTextContent = true;
	} else if (action.value == "colors") {
		state.const_var.colorsHelpTextContent = true;
	} else if (action.value == "buildsize") {
		state.const_var.buildSizeHelpTextContent = true;
		if (action.id == "gaugeCertificatescroll") {
			setTimeout(function () {
				let ele = document.getElementById(action.id);
				ele.scrollIntoView();
			}, 100);
		}

		if (action.id == "roofscroll") {
			setTimeout(function () {
				let ele = document.getElementById(action.id);
				ele.scrollIntoView();
			}, 100);
		}

		if (action.id == "instalaltionscroll") {
			setTimeout(function () {
				let ele = document.getElementById(action.id);
				ele.scrollIntoView();
			}, 100);
		}
	} else if (action.value == "leanto") {
		state.const_var.leantoHelpTextContent = true;
	} else if (action.value == "doorwindow") {
		state.const_var.doorWindowHelpTextContent = true;
	} else if (action.value == "extraoption") {
		state.const_var.extraHelpTextContent = true;

		if (action.id == "extraoptionscroll") {
			setTimeout(function () {
				let ele = document.getElementById(action.id);
				ele.scrollIntoView();
			}, 100);
		}

		if (action.id == "jtrimscroll") {
			setTimeout(function () {
				let ele = document.getElementById(action.id);
				ele.scrollIntoView();
			}, 100);
		}
	} else if (action.value == "walls") {
		state.const_var.extraHelpTextContent = true;

		if (action.id == "wallsscroll") {
			setTimeout(function () {
				let ele = document.getElementById(action.id);
				ele.scrollIntoView();
			}, 100);
		}

		if (action.id == "addinsulationscroll") {
			setTimeout(function () {
				let ele = document.getElementById(action.id);
				ele.scrollIntoView();
			}, 100);
		}
	}

	return {
		...state,
		newColor: state.isShowWhatThis + "isShowWhatThis"
	};
};
export const SetPriceCompareForNonLoggedIn = (state, action) => {
	if (action.value == "" && action.key == "") {
		let stateId = params.p_s_n;
		let selectedState = const_var.bjDData.find((state) => state.id == stateId);
		if (selectedState == undefined && params.p_s_n == "") {
			if (const_var.bjDData != undefined) {
				stateId = const_var.bjDData[0].id;
				params.p_s_n = stateId;
				selectedState = const_var.bjDData[0];
				params.manufactureKey = const_var.bjDData[0].manufacturer_list[0].u_id;
				params.m_s_n = const_var.bjDData[0].manufacturer_list[0].id;

				const_var.manufacturer_discount_label = "";
				const_var.manufacturer_discount_changed = false;
				const_var.edited_manufacturer_discount_label = "";
			}
		}
		if (selectedState && !const_var.loginSession && selectedState?.manufacturer_list?.price_comparision?.length > 0) {
			const key = `selectedState_${stateId}`;
			state.nonLoggedInpriceCompareData = {
				...state.nonLoggedInpriceCompareData,
				[key]: selectedState?.manufacturer_list[0]?.price_comparision
			};
		}
	} else {
		state.nonLoggedInpriceCompareData = {
			...state.nonLoggedInpriceCompareData,
			[action.key]: action.value
		};
	}
	return {
		...state,
		newColor: state.nonLoggedInpriceCompareData
	};
};

export const handleCloseDoorWindow = (state, action) => {
	state.const_var.showComponentEditBox = false;
	state.isShowEditIconSection = false;
	const_var.b_s_c_n = null;
	clearTimeout(const_var.timer);
	let tempDoorArr = [...const_var.newDoorsArray];
	state.const_var.newDoorsArray = tempDoorArr;
	let newDataArra = [];
	if (const_var.newDoorsArray) {
		const_var.newDoorsArray.map((item, index) => {
			let findIndex = const_var.entry_points.findIndex((data) => data.uniqueId == item.uniqueId);
			if (findIndex !== -1) {
				newDataArra.push(const_var.entry_points[findIndex]);
			}
		});
	}
	if (newDataArra.length == const_var.newDoorsArray.length) {
		const_var.entry_points = newDataArra;
	}
	return {
		...state,
		action,
		newColor: const_var.showComponentEditBox + action.uniqueid + 1
	};
};
export const handleClose = (state, action) => {
	state.isShowThankYou = false;
	state.const_var.checkoutModal = false;
	state.isShowWhatThis = false;
	state.isShowfeedback = false;
	state.isShowSummaryModal = false;
	state.const_var.agreeTermsAndConditionCheckbox = false;
	state.const_var.backToCheckoutBtn = true;
	state.const_var.showComponentEditBox = false;
	state.const_var.displayerrorMessage = {};
	state.isCustomer = false;
	state.isEdit = false;
	state.isaddCustomer = false;
	state.createLeadOnly = false;
	state.const_var.createLeadOnly = false;
	state.saveLatterModal = false;
	state.const_var.saveLatterModal = false;
	state.const_var.leadCreatedSuccessfully = false;
	return {
		...state,
		newColor: state.const_var.checkoutModal + state.isShowSummaryModal
	};
};
export const dragUtilityPriceReset = (state, action) => {
	if (action.val == "front") {
		state.const_var.onDragUtilityPriceUpdateFront = false;
	}
	if (action.val == "back") {
		state.const_var.onDragUtilityPriceUpdateBack = false;
	}
	if (action.val == "left") {
		state.const_var.onDragUtilityPriceUpdateLeft = false;
	}
	if (action.val == "right") {
		state.const_var.onDragUtilityPriceUpdateRight = false;
	}
	if (action.val == "center_building") {
		state.const_var.onDragUtilityPriceUpdateCenterBuilding = false;
	}
	return {
		...state,
		newColor: action
	};
};
export const handleRemoveComponent = (state, action, cuComponent) => {
	state.const_var.doorUniqueId = action.uniqueId;

	if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
		const_var.UpdatedPriceData.certificate_price_changed = true;
	}
	updateWainscotPriceFlag();
	if (!action.isDropdownChange) {
		state.const_var.showComponentEditBox = false;
	}
	cuComponent.removeComponentFromWall(action.uniqueId);

	return {
		...state,
		newColor: state.const_var.isShowAlert + action.uniqueId + state.const_var.showComponentEditBox + state.const_var.alertUsedFor + state.const_var.showComponentDeleteAlert
	};
};
export const handlePublicEdit = (state, action) => {
	if (action.actionType == undefined) {
		if (action.key === "fromheader") {
			const_var.crmSetting.is_quote_Edit = false;
			const_var.hide_price_calculation = 0;
			document.querySelector("body").classList.remove("active-hidden-price");
			document.querySelector("body").classList.add("hidden-customer-edit");
			setTimeout(function () {
				cuComponent.onResize();
			}, 500);
		} else {
			state.isShowSummaryModal = !state.isShowSummaryModal;
			const_var.crmSetting.is_quote_Edit = false;
			const_var.hide_price_calculation = 0;
			document.querySelector("body").classList.remove("active-hidden-price");
			document.querySelector("body").classList.add("hidden-customer-edit");
			setTimeout(function () {
				cuComponent.onResize();
			}, 500);
		}
	} else {
		if (action.key != "fromheader") {
			state.isShowSummaryModal = !state.isShowSummaryModal;
		}
		const_var.crmSetting.is_quote_Edit = true;
		state.const_var.isShowAlert = true;
		state.const_var.alertUsedFor = "publicAccessURL";
		const_var.alertPubliMessage = action.value;
		const_var.isPublicUrlNonEditable = true;
		document.querySelector("body").classList.remove("active-hidden-price");
		document.querySelector("body").classList.add("hidden-customer-edit");
		setTimeout(function () {
			cuComponent.onResize();
		}, 500);
	}
	return {
		...state,
		newColor: action.value + action.actionType + const_var.crmSetting.is_quote_Edit + const_var.selectedTabKeyForWheel + state.isShowSummaryModal
	};
};
export const handleChangeAccordianBg = (state, action) => {
	document.querySelector("body").classList.add("canvasloaderbg");
	setTimeout(() => {
		document.querySelector("body").classList.remove("canvasloaderbg");
	}, 1000);
	state.const_var.crmSetting.is_show_background = !state.const_var.crmSetting.is_show_background;
	if (state.const_var.crmSetting.is_show_background == true) {
		document.querySelector("body").classList.add("activebuildingbg");
	} else {
		document.querySelector("body").classList.remove("activebuildingbg");
	}

	return {
		...state,
		newColor: const_var.crmSetting.is_show_background + state.const_var.doorWall + state.const_var.doorWallArrayValue + params.isShowCenter + const_var.canvasbgloader
	};
};
export const resetAllEditValue = (state, action) => {
	state.const_var.UpdatedPriceData = {
		roof_style_price_changed: true,
		lifttype_price_changed: true,
		cupola_price_changed: true,
		width_price_changed: true,
		length_price_changed: true,
		height_price_changed: true,
		left_wall_price_changed: true,
		right_wall_price_changed: true,
		right_wall_cut_panel_price_changed: true,
		left_wall_cut_panel_price_changed: true,
		front_wall_price_changed: true,
		back_wall_price_changed: true,
		certificate_price_changed: true,
		common_width_changed: true,
		common_length_changed: true,
		common_height_changed: true,
		utility_price_changed: true,
		wainscot_price_changed: true,
		connection_fee_end_changed: true,
		connection_fee_side_changed: true,
		roof_pitch_price_changed: true,
		lifttype_price_changed: true,
		left_lean_roof_style_price_changed: true,
		left_lean_width_price_changed: true,
		left_lean_length_price_changed: true,
		left_lean_height_price_changed: true,
		left_lean_left_wall_price_changed: true,
		left_lean_front_wall_price_changed: true,
		left_lean_back_wall_price_changed: true,
		left_lean_certificate_price_changed: true,
		left_lean_utility_price_changed: true,
		left_lean_roof_pitch_price_changed: true,
		right_lean_roof_style_price_changed: true,
		right_lean_width_price_changed: true,
		right_lean_length_price_changed: true,
		right_lean_height_price_changed: true,
		right_lean_right_wall_price_changed: true,
		right_lean_front_wall_price_changed: true,
		right_lean_back_wall_price_changed: true,
		right_lean_certificate_price_changed: true,
		right_lean_utility_price_changed: true,
		right_lean_roof_pitch_price_changed: true,
		front_lean_roof_style_price_changed: true,
		front_lean_width_price_changed: true,
		front_lean_length_price_changed: true,
		front_lean_height_price_changed: true,
		front_lean_left_wall_price_changed: true,
		front_lean_front_wall_price_changed: true,
		front_lean_back_wall_price_changed: true,
		front_lean_certificate_price_changed: true,
		front_lean_utility_price_changed: true,
		front_lean_roof_pitch_price_changed: true,
		back_lean_roof_style_price_changed: true,
		back_lean_width_price_changed: true,
		back_lean_length_price_changed: true,
		back_lean_height_price_changed: true,
		back_lean_left_wall_price_changed: true,
		back_lean_front_wall_price_changed: true,
		back_lean_back_wall_price_changed: true,
		back_lean_certificate_price_changed: true,
		back_lean_utility_price_changed: true,
		back_lean_roof_pitch_price_changed: true,
		color_price_changed: true,
		down_payment_type: "per",
		down_payment_discount_type: "per",
		discount_type: "per",
		left_front_wrap_connection_fee_changed: true,
		right_front_wrap_connection_fee_changed: true,
		right_back_wrap_connection_fee_changed: true,
		left_back_wrap_connection_fee_changed: true,
		front_lean_insulation_price_changed: true,
		left_lean_insulation_price_changed: true,
		right_lean_insulation_price_changed: true,
		back_lean_insulation_price_changed: true,
		wall_color_price_changed: true,
		roof_color_price_changed: true,
		trim_color_price_changed: true,
		wainscot_price_changed: true,
		truss_price_changed: true,
		left_lean_right_wall_price_changed: true,
		right_lean_left_wall_price_changed: true,
		front_lean_right_wall_price_changed: true,
		back_lean_right_wall_price_changed: true,
		siding_material_price_changed: true,
		frontLean_truss_price_changed: true,
		backLean_truss_price_changed: true,
		rightLean_truss_price_changed: true,
		leftLean_truss_price_changed: true,
		common_left_lean_length_changed: true,
		common_right_lean_length_changed: true,
		common_front_lean_length_changed: true,
		common_back_lean_length_changed: true,
		common_left_lean_width_changed: true,
		common_right_lean_width_changed: true,
		common_front_lean_width_changed: true,
		common_back_lean_width_changed: true
	};
	return {
		...state,
		action
	};
};
export const setComparisonBuildingLoader = (state, action) => {
	if (action.mfgindex == "_1") {
		state.const_var.comparisionLoadermfg1 = true;
		if ((params.add_front_lean || params.add_back_lean) && const_var.compare_leanto_condition_by_mfg.end_lean_to == false) {
			state.const_var.comparisionLoadermfg1 = false;
		}
	}

	if (action.mfgindex == "_2") {
		state.const_var.comparisionLoadermfg2 = true;
		if ((params.add_front_lean || params.add_back_lean) && const_var.compare_leanto_condition_by_mfg.end_lean_to == false) {
			state.const_var.comparisionLoadermfg2 = false;
		}
	}

	return {
		...state,
		action,
		newColor: state.const_var.comparisionLoadermfg1 + state.const_var.comparisionLoadermfg2
	};
};
export const handleSelectedTab = (state, action) => {
	{
		state.const_var.selectedTabKeyForWheel = action.key;
		state.const_var.tabCountDisplay = true;
		if (action.key == "statechange") {
			state.const_var.tabCountDisplay = false;
			state.const_var.confirmState = false;
		}
		if (action.key != "doorwindow") {
			state.doorWindowIconsPos = [];
		}

		if (action.key === "doorwindow") {
			cuComponent.cameraFocusOnWall(state, params.activeWall);
		} else if (const_var.focusedSection !== "") {
			const_var.focusedSection = "";
		}

		state.const_var.ClickforPhotosMobile = React.createRef();

		if (
			action.key == "capture" &&
			state.const_var.crmSetting.parent_api_token != "lSnJFZzVzjafjqu1530dlyobYTsubogpP5SXJRYpIVEL0yPfvcWusou7Vhg6Coor" &&
			state.const_var.crmSetting.main_domain_url != "Leadingsteelbuildings.com"
		) {
			document.querySelector("body").classList.add("active-mobile-capture");

			if (const_var.i_g_A_y.length > 0) {
			} else {
				setTimeout(() => {
					document.querySelector("body").classList.remove("active-offset-thumbnail");

					state.const_var.ClickforPhotosMobile.current.click();
				}, 100);
			}
		} else {
			document.querySelector("body").classList.remove("active-mobile-capture");
		}

		return {
			...state,
			selectedTabKey: action.key
		};
	}
};
export const handleSelectedTabState = (state, action) => {
	{
		if (state.const_var.showLoginScreen) {
			state.const_var.showLoginScreen = false;
		}
		if (action.key == "statechange") {
			state.const_var.isForStandardBuilding = false;
			state.const_var.confirmState = false;
		}
		if (action.key == "loginstyletab") {
			const_var.isFromPickThis = false;
		}
		state.const_var.selectedTabstate = action.key;
		state.selectedTabKey = action.key;
		state.const_var.selectedTabKeyForWheel = state.selectedTabKey;
		state.const_var.showComponentEditBox = false;
		state.const_var.tabCountStateDisplay = true;
		state.doorWindowIconsPos = [];
		state.cupolaEditIconsPos = [];
		if (const_var.focusedSection !== "") {
			const_var.focusedSection = "";
		}

		return {
			...state,
			selectedTabstate: action.key
		};
	}
};
export const setZipCodeValue = (state, action) => {
	state.const_var.ziperrormsg = "";

	state.const_var.zipManufErrMsg = "";
	if (action.value != undefined && action.value.length < 5 && const_var.showStateField) {
		const_var.showStateField = false;
		const_var.showStateOnly = false;
		state.const_var.bjDData = [];
		state.const_var.bjD = [];
	}
	if (const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen == true) {
		state.const_var.state_mfg_zipcode = action.value;
		state.const_var.zipCode = action.value;
		if (action.key == "statemanufacturechangepage") {
			const_var.crmSetting.is_Edit = false;
		}
		if (action.value != undefined && action.value.length < 5) {
			state.const_var.showStateZip = false;
		}
		if (action.value == "") {
			state.params.p_s_n = "";
			state.params.m_s_n = "";
			state.const_var.stateManufacturerAcordingAPIDiscount = {};
			state.const_var.bjDData = [];
		}
	} else {
		state.const_var.zipCode = action.value;
		if (action.value == "") {
			state.params.p_s_n = "";
			state.params.m_s_n = "";
			state.const_var.stateManufacturerAcordingAPIDiscount = {};
			state.const_var.bjDData = [];
		}
	}
	state.const_var.MFApiCalled = false;
	state.const_var.SApiCalled = false;
	return {
		...state,
		action
	};
};
export const handleCompanySelection = (state, action) => {
	const_var.post_data["company_id"] = action.value;
	params.company_id = action.value;
	const_var.LeadCustomerData = {};
	const_var.crmSetting.sub_module_id = "";

	if (action.from == "state") {
		const_var.isCompanyIdChanged = true;
		const_var.companyIdSelectedFromStateScreen = params.company_id;
		params.p_s_n = "";
		params.m_s_n = "";
		const_var.stateManufacturerAcordingAPI = {};
		const_var.stateManufactureDataFromApi = [];
		const_var.confirmState = false;
	}
	if (action.from == "tooltip") {
		const_var.isCompanyIdChanged = true;
	}
	return {
		...state,
		action
	};
};
export const handleActiveTabPanel = (state, action) => {
	let newAction;

	if (action.key != undefined && action.key != null) {
		const_var.activeTab = action.key;
		newAction = const_var.activeTab;
	} else {
		const_var.activeTab = null;
		newAction = const_var.activeTab;
	}
	return {
		...state,
		newAction
	};
};
export const checkSharingAlertBox = (state, action) => {
	if (action.value == "show") {
		const_var.SharingAlertBox = true;
	}
	if (action.value == "true") {
		const_var.SharingAlertBox = false;
		window.location.href = window.location.href = const_var.crmSetting.web_url + "/" + const_var.targetRedirectUrl[const_var.crmSetting.is_module_name].view + const_var.crmSetting.is_module_id;
	}
	return {
		...state,
		newColor: action
	};
};
export const showHideTransulent = (state, action, controls) => {
	if (action.key != "doorwindow") {
		params.is_translusant = !params.is_translusant;
	} else {
		params.is_translusant = false;
	}
	makeTranslucent(controls.isCheckActiveTab, params.activeWall, params.is_translusant, const_var.scene);
	return {
		...state,
		newData: params.is_translusant + Date.now()
	};
};
export const handleGeneratePrintimages = (state, action) => {
	const_var.PrintAlertBox = action.payload;
	if (const_var.PrintAlertBox == true && const_var.i_g_A_y.length < 1) {
		const_var.selectedTabKeyForWheel = "capture";
		const_var.activeTab = "buildingtypetab";
		cuComponent.TsCeSot("print");
	}
	return {
		...state,
		action
	};
};
export const globalZipState = (state, action) => {
	if (action.value != undefined && action.value != "") {
		const_var.isGlobalZipUpdate = action.value;
	} else {
		const_var.zipcodeToolTipDataFlag = true;
	}
	return {
		...state,
		action,
		newColor: const_var.isGlobalZipUpdate + const_var.zipcodeToolTipDataFlag
	};
};
